"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const StickyCard_1 = __importDefault(require("../StickyCard"));
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
// eslint-disable-next-line max-lines-per-function
function ImageCard({ identifier, image, rect, selectedToolType, setSelectedID, setSelectedType, }) {
    var _a, _b;
    const tools = (0, providers_1.useToolsService)();
    const stickies = (0, hooks_1.useStickiesState)();
    const sticky = stickies.find(s => s.identifier === identifier);
    const selectedId = (0, hooks_1.useSelectedID)();
    const onClick = (0, react_1.useCallback)(() => {
        if (setSelectedID) {
            setSelectedID(identifier);
        }
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().selectSticky(identifier);
        if (selectedId !== identifier && selectedToolType !== bridge_schema_1.ToolType.None) {
            if (setSelectedType) {
                setSelectedType(bridge_schema_1.ToolType.None);
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [identifier, selectedId, selectedToolType, setSelectedID, setSelectedType]);
    const onResizing = (0, react_1.useCallback)((newSize) => {
        if (!tools || !identifier)
            return;
        if (!sticky)
            return;
        const { width: originalWidth, height: originalHeight } = sticky.stickyRect;
        let adjustedWidth = newSize.width;
        let adjustedHeight = newSize.height;
        if (newSize.width !== originalWidth) {
            adjustedHeight = (newSize.width * originalHeight) / originalWidth;
            adjustedWidth = newSize.width;
        }
        else if (newSize.height !== originalHeight) {
            adjustedWidth = (newSize.height * originalWidth) / originalHeight;
            adjustedHeight = newSize.height;
        }
        tools.getStickiesToolManager().updateSticky({
            identifier,
            stickyRect: {
                width: adjustedWidth,
                height: adjustedHeight,
            },
        });
    }, [tools, identifier, sticky]);
    const onResizeEnd = (0, react_1.useCallback)((newSize) => {
        if (!sticky)
            return;
        const { width: originalWidth, height: originalHeight } = sticky.stickyRect;
        let adjustedWidth = newSize.width;
        let adjustedHeight = newSize.height;
        if (newSize.width !== originalWidth) {
            adjustedHeight = (newSize.width * originalHeight) / originalWidth;
        }
        else {
            adjustedWidth = (newSize.height * originalWidth) / originalHeight;
        }
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
            identifier,
            stickyRect: {
                width: adjustedWidth,
                height: adjustedHeight,
            },
        });
    }, [tools, identifier, sticky]);
    return ((0, jsx_runtime_1.jsx)(StyledStickyCard, { identifier: identifier, rect: rect, canDrag: true, onClick: onClick, onDoubleClick: onClick, onResizing: onResizing, onResizeEnd: onResizeEnd, "data-e2e": 'ImageCard_StyledStickyCard', children: (0, jsx_runtime_1.jsx)(Image, { src: (0, ui_1.fixRelativeUrl)(image), "data-e2e": 'ImageCard_Image' }) }, `${(_a = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _a === void 0 ? void 0 : _a.x}-${(_b = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _b === void 0 ? void 0 : _b.y}`));
}
exports.default = (0, react_1.memo)(ImageCard, (prevProps, nextProps) => {
    return (0, isEqual_1.default)(prevProps, nextProps);
});
const StyledStickyCard = (0, styled_components_1.default)(StickyCard_1.default) `
  padding: 0;
`;
const Image = styled_components_1.default.img `
  width: 100%;
  height: 100%;

  pointer-events: none;

  margin: auto 0 0 0;
`;
